import { GetApp, Refresh } from '@material-ui/icons';
import { DateRangeSelector } from './DateRangeSelector';
import { timespans } from '../../lib/constants';
import { useEffect, useState } from 'react';
import { useOperator } from '../../contexts/OperatorContext';
import { IconButton } from '../IconButton';
import { TableColumn } from '../../types/commonTypes';
import { downloadCsv } from '../../lib/csv';

interface Props {
  enableTimespan: boolean;
  exportColumns?: TableColumn[];
  exportData?: any[];
  exportTitle?: string;
  refresh: boolean;
  onRefresh(item: any): void;
}

export const DynamicFooter = ({
  exportColumns,
  exportData,
  exportTitle,
  refresh,
  onRefresh,
  enableTimespan,
}: Props) => {
  const [dateRange, setDateRange] = useState(timespans[0]);

  const operator = useOperator();

  const handleRefresh = () => {
    onRefresh(dateRange ? dateRange : null);
  };

  useEffect(() => {
    handleRefresh();
  }, [dateRange.name, operator.id]);

  return (
    <div className="flex flex-row justify-between w-full h-[50px] p-1">
      {enableTimespan ? (
        <DateRangeSelector dateRange={dateRange} onDateChange={setDateRange} />
      ) : null}
      {refresh ? (
        <IconButton onClick={handleRefresh}>
          <Refresh />
        </IconButton>
      ) : null}
      {exportColumns && exportData && exportTitle && (
        <IconButton
          onClick={() =>
            downloadCsv(exportColumns, exportData, exportTitle, true)
          }
        >
          <GetApp />
        </IconButton>
      )}
    </div>
  );
};
